/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import YesNoDialog from "../../../../Basis/Components/YesNoDialog";
import useNavigate from "../../../../Basis/Utils/useNavigate";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nMandanten";

export interface FirmendatenFehlenDialogProps {
    isOpen: boolean;
    onOk: () => void;
    onAbgebrochen: () => void;
}

export default function FirmendatenFehlenDialog(props: FirmendatenFehlenDialogProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    function handleYes() {
        navigate("/mandant/firmendaten")
        props.onOk();
    }

    function handleNo() {
        props.onAbgebrochen();
    }

    return (
        <YesNoDialog
            isOpen={props.isOpen}
            onYes={handleYes}
            onNo={handleNo}
            dialogCaption={t(translationKeys.firmendatenFehlenDialog.dialogCaption)}
            dialogText={t(translationKeys.firmendatenFehlenDialog.dialogText)}
            jaCaption={t(translationKeys.firmendatenFehlenDialog.zuDenFirmendaten)}
            neinCaption={t(translationKeys.firmendatenFehlenDialog.abbrechen)}
            variant="standard"
            focusOn="yes"
        />
    );
}
